import { render, staticRenderFns } from "./addressComponent.vue?vue&type=template&id=70ee3f4a&scoped=true&"
import script from "./addressComponent.vue?vue&type=script&lang=js&"
export * from "./addressComponent.vue?vue&type=script&lang=js&"
import style0 from "./addressComponent.vue?vue&type=style&index=0&id=70ee3f4a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ee3f4a",
  null
  
)

export default component.exports